import type { Profile } from '@/types'

export const DEFAULT_PROFILES: Profile[] = [
  {
    id: 'anthropic-direct-sonnet',
    name: 'Direct API - Sonnet 4',
    type: 'anthropic-direct',
    region: 'us-east-1',
    modelId: 'claude-sonnet-4-20250514',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  },
  {
    id: 'anthropic-direct-sonnet-45',
    name: 'Direct API - Sonnet 4.5',
    type: 'anthropic-direct',
    region: 'us-east-1',
    modelId: 'claude-sonnet-4-5-20250929',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  },
  {
    id: 'anthropic-direct-opus-45',
    name: 'Direct API - Opus 4.5',
    type: 'anthropic-direct',
    region: 'us-east-1',
    modelId: 'claude-opus-4-5-20251101',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  },
  {
    id: 'anthropic-direct-opus-46',
    name: 'Direct API - Opus 4.6',
    type: 'anthropic-direct',
    region: 'us-east-1',
    modelId: 'claude-opus-4-20250514',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  },
  {
    id: 'anthropic-direct-haiku-45',
    name: 'Direct API - Haiku 4.5',
    type: 'anthropic-direct',
    region: 'us-east-1',
    modelId: 'claude-haiku-4-5-20251001',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  },
  {
    id: 'bedrock-no-gr',
    name: 'Bedrock - Sonnet 4.6',
    type: 'bedrock',
    region: 'us-east-1',
    modelId: 'us.anthropic.claude-sonnet-4-6',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  },
  {
    id: 'bedrock-sonnet-45',
    name: 'Bedrock - Sonnet 4.5',
    type: 'bedrock',
    region: 'us-east-1',
    modelId: 'us.anthropic.claude-sonnet-4-5-20250929-v1:0',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  },
  {
    id: 'bedrock-opus-45',
    name: 'Bedrock - Opus 4.5',
    type: 'bedrock',
    region: 'us-east-1',
    modelId: 'us.anthropic.claude-opus-4-5-20251101-v1:0',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  },
  {
    id: 'bedrock-opus-46',
    name: 'Bedrock - Opus 4.6',
    type: 'bedrock',
    region: 'us-east-1',
    modelId: 'us.anthropic.claude-opus-4-6-v1',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  },
  {
    id: 'bedrock-haiku-45',
    name: 'Bedrock - Haiku 4.5',
    type: 'bedrock',
    region: 'us-east-1',
    modelId: 'us.anthropic.claude-haiku-4-5-20251001-v1:0',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  },
  {
    id: 'bedrock-sonnet-46-gr',
    name: 'Bedrock - Sonnet 4.6 + Guardrail',
    type: 'bedrock-guardrail',
    region: 'us-east-1',
    modelId: 'us.anthropic.claude-sonnet-4-6',
    guardrailId: '',
    guardrailVersion: 'DRAFT',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  },
  {
    id: 'bedrock-opus-45-gr',
    name: 'Bedrock - Opus 4.5 + Guardrail',
    type: 'bedrock-guardrail',
    region: 'us-east-1',
    modelId: 'us.anthropic.claude-opus-4-5-20251101-v1:0',
    guardrailId: '',
    guardrailVersion: 'DRAFT',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  },
  {
    id: 'bedrock-opus-46-gr',
    name: 'Bedrock - Opus 4.6 + Guardrail',
    type: 'bedrock-guardrail',
    region: 'us-east-1',
    modelId: 'us.anthropic.claude-opus-4-6-v1',
    guardrailId: '',
    guardrailVersion: 'DRAFT',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  },
  {
    id: 'bedrock-haiku-45-gr',
    name: 'Bedrock - Haiku 4.5 + Guardrail',
    type: 'bedrock-guardrail',
    region: 'us-east-1',
    modelId: 'us.anthropic.claude-haiku-4-5-20251001-v1:0',
    guardrailId: '',
    guardrailVersion: 'DRAFT',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  },
  {
    id: 'bedrock-guardrail',
    name: 'Bedrock + Guardrail (template)',
    type: 'bedrock-guardrail',
    region: 'us-east-1',
    modelId: 'us.anthropic.claude-sonnet-4-6-20250514-v1:0',
    guardrailId: '',
    guardrailVersion: 'DRAFT',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  },
  {
    id: 'grok-default',
    name: 'Grok - grok-3-mini-fast',
    type: 'grok',
    region: 'us-east-1',
    modelId: 'grok-3-mini-fast',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  },
  {
    id: 'grok-3-fast',
    name: 'Grok - grok-3-fast',
    type: 'grok',
    region: 'us-east-1',
    modelId: 'grok-3-fast',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  },
  {
    id: 'grok-4-fast',
    name: 'Grok - grok-4-fast (non-reasoning)',
    type: 'grok',
    region: 'us-east-1',
    modelId: 'grok-4-fast-non-reasoning',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  },
  {
    id: 'bedrock-proxy',
    name: 'Bedrock + Proxy',
    type: 'bedrock-proxy',
    region: 'us-east-1',
    modelId: 'us.anthropic.claude-sonnet-4-6-20250514-v1:0',
    guardrailId: '',
    guardrailVersion: 'DRAFT',
    proxyUrl: '',
    maxTokens: 256,
    prompt: 'Count from 1 to 10.',
    enabled: false
  }
]

export const PROMPT_PRESETS = {
  simple: {
    label: 'Simple',
    prompt: 'Count from 1 to 10.',
    maxTokens: 256
  },
  medium: {
    label: 'Medium',
    prompt: 'Explain the key differences between TCP and UDP protocols. Include use cases, advantages, and disadvantages of each.',
    maxTokens: 1024
  },
  complex: {
    label: 'Complex',
    prompt: 'Design a complete REST API for a multi-tenant SaaS project management system. Include: 1) Database schema with at least 8 tables, 2) API endpoints for CRUD operations, 3) Auth strategy with RBAC, 4) Rate limiting and pagination, 5) Error handling patterns with JSON examples.',
    maxTokens: 4096
  },
  codegen: {
    label: 'Code Gen',
    prompt: 'Write a Python function that implements binary search on a sorted list. Include type hints, error handling for edge cases, and docstring with examples.',
    maxTokens: 512
  },
  bugfix: {
    label: 'Bug Fix',
    prompt: 'This Python code throws IndexError. Find and fix the bug, explain the root cause, and add a test case:\n\ndef get_last(items):\n    return items[len(items)]',
    maxTokens: 512
  },
  review: {
    label: 'Code Review',
    prompt: 'Review this code for security issues, performance problems, and best practices. Provide specific fixes:\n\napp.get(\'/user/:id\', (req, res) => {\n  db.query(\'SELECT * FROM users WHERE id = \' + req.params.id)\n    .then(rows => res.json(rows))\n})',
    maxTokens: 1024
  },
  testgen: {
    label: 'Test Gen',
    prompt: 'Write unit tests using Jest for a function calculateDiscount(price, customerType) that gives 10% for "premium", 20% for "vip", 0% for others. Throw on negative price. Include edge cases.',
    maxTokens: 1024
  },
  refactor: {
    label: 'Refactor',
    prompt: 'Refactor this callback-based code to use async/await with proper error handling:\n\nfs.readFile(\'data.json\', (err, data) => {\n  if (err) { console.log(err); return; }\n  JSON.parse(data, (err2, obj) => {\n    if (err2) { console.log(err2); return; }\n    db.save(obj, (err3) => {\n      if (err3) console.log(err3);\n    });\n  });\n});',
    maxTokens: 512
  },
  architecture: {
    label: 'Architecture',
    prompt: 'Design the database schema for a multi-tenant task management app with PostgreSQL. Include tables, relationships, indexes, and explain partitioning strategy for tenant isolation.',
    maxTokens: 4096
  },
  classify: {
    label: 'Classify',
    prompt: 'Classify this sentiment as positive, negative, or neutral: "The product works fine but shipping was slow." Respond with one word only.',
    maxTokens: 16
  },
  json: {
    label: 'JSON Output',
    prompt: 'Return a JSON object with fields: name, age, city, occupation, hobbies (array of 3), skills (object with 3 key-value pairs). Use realistic fake data.',
    maxTokens: 256
  }
} as const

export type PromptComplexity = keyof typeof PROMPT_PRESETS | 'custom'
